import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import type { Charger } from '../../api/chargers';
import { StatusLabel } from '../../components/StatusLabel';
import { formatDateTime } from '../../lib/format';
import { connectorsOf, STATUS_DISPLAY } from './status';

/** One line per socket: "Charging", or "1 Charging / 2 Available" on a dual charger. */
export function ConnectorStatuses({ charger }: { charger: Charger }) {
  const list = connectorsOf(charger);
  return (
    <Box sx={{ display: 'grid', gap: 0.5 }}>
      {list.map((k) => {
        const d = STATUS_DISPLAY[k.status];
        const detail = [k.errorCode && k.errorCode !== 'NoError' ? k.errorCode : null, k.info, k.at ? `since ${formatDateTime(k.at)}` : null].filter(Boolean).join(' · ');
        const label = list.length > 1 ? `${k.connectorId} ${d.label}` : d.label;
        return (
          <Tooltip key={k.connectorId} title={detail} placement="top-start" disableInteractive describeChild>
            <Box component="span" sx={{ width: 'fit-content' }}>
              <StatusLabel tone={d.tone}>{label}</StatusLabel>
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
}
